import React from "react";
import { Link, useLocation } from "react-router-dom";

// Item del SideBar. En desktop renderiza solo ícono (compact 44x44).
// En mobile (showName) renderiza ícono + nombre en una fila ancha,
// touch-friendly (>=44px alto).
//
// onClick se usa en mobile para cerrar el drawer al navegar.
const SideBarIcon = ({ icon, path, name = "", showName = false, onClick }) => {
  const location = useLocation();
  const isActive = location.pathname.startsWith(`/${path}`);

  // Estilos base + diferenciación desktop/mobile
  const base = {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    transition: "background .15s, color .15s",
    // Sidebar oscuro (identidad del logo ERP): item activo en rojo de marca.
    background: isActive ? "#e30613" : "transparent",
    color: isActive ? "#fff" : "rgba(255,255,255,0.6)",
    position: "relative",
  };

  const desktopStyle = {
    ...base,
    justifyContent: "center",
    width: 44,
    height: 44,
    borderRadius: 8,
    margin: "2px 0",
    fontSize: 20,
  };

  const mobileStyle = {
    ...base,
    width: "100%",
    height: 48,
    padding: "0 16px",
    gap: 14,
    fontSize: 16,
    borderRadius: 0,
  };

  const style = showName ? mobileStyle : desktopStyle;

  return (
    <Link
      to={`/${path}`}
      title={name}
      onClick={onClick}
      style={style}
      onMouseEnter={(e) => {
        if (!isActive) {
          e.currentTarget.style.background = "rgba(227,6,19,0.18)";
          e.currentTarget.style.color = "#fff";
        }
      }}
      onMouseLeave={(e) => {
        if (!isActive) {
          e.currentTarget.style.background = "transparent";
          e.currentTarget.style.color = "rgba(255,255,255,0.6)";
        }
      }}
    >
      <i
        className={`bi bi-${icon}`}
        style={showName ? { fontSize: 20, width: 24, textAlign: "center" } : undefined}
      />
      {showName && <span>{name}</span>}
    </Link>
  );
};

export default SideBarIcon;
